import { render, staticRenderFns } from "./MoleculeEditionMapEnrollmentsSubMenu.vue?vue&type=template&id=2d4d8cf7&"
import script from "./MoleculeEditionMapEnrollmentsSubMenu.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionMapEnrollmentsSubMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports